// vm-load-more (L3, patch 19). OB9-2 (9 Oct 2026, R4-08): Shopify search can count 32 on one request and
// 33 on the next, so after an append the line is recounted from the cards actually in the grid (duplicates
// dropped), "Show N more" matches what the next click appends, and the toolbar count follows.
const say = (n) => `${n} ${n === 1 ? 'piece' : 'pieces'}`;
class VmLoadMore extends HTMLElement {
  connectedCallback() {
    this.onclick = (e) => {
      const a = e.target.closest('[data-vm-more]');
      if (!a || this.busy) return;
      e.preventDefault();
      this.busy = a.ariaBusy = 'true';
      const u = new URL(a.href);
      u.searchParams.set('section_id', this.dataset.section);
      const grid = this.parentElement.querySelector('ul.product-grid');
      fetch(u).then((r) => r.text()).then((t) => {
        const d = new DOMParser().parseFromString(t, 'text/html');
        const seen = new Set([...grid.querySelectorAll(':scope > li[data-product-id]')].map((l) => l.dataset.productId));
        const li = [...d.querySelectorAll('ul.product-grid > li')].filter((l) => {
          const id = l.dataset.productId;
          if (id && seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        grid.append(...li);
        const next = d.querySelector('vm-load-more');
        this.replaceWith(next || '');
        if (next) VmLoadMore.recount(next, grid);
        li[0]?.querySelector('a[href]')?.focus({ preventScroll: true });
      }).catch(() => (location.href = a.href));
    };
  }

  /** Line, bar and link from the cards in the grid; the toolbar count follows the settled total. */
  static recount(el, grid) {
    const shown = grid.querySelectorAll(':scope > li[data-product-id]').length;
    const size = Number(el.dataset.size) || 24;
    const link = el.querySelector('[data-vm-more]');
    let total = Number(el.dataset.total) || shown;
    if (!link || total <= shown) {
      total = shown;
      link?.remove();
    } else {
      link.textContent = `Show ${Math.min(size, total - shown)} more`;
    }
    const count = el.querySelector('.vm-more__count');
    if (count) count.textContent = `Showing ${shown} of ${total}`;
    el.querySelector('.vm-more__bar')?.style.setProperty('--vm-more-p', `${Math.floor((shown * 100) / total)}%`);
    for (const c of document.querySelectorAll('.vm-toolbar__count')) {
      if (c.textContent.trim() !== say(total)) c.textContent = say(total);
    }
  }
}
customElements.get('vm-load-more') || customElements.define('vm-load-more', VmLoadMore);
